import PayoutListOptions from '@/components/Payout/PayoutListOptions.vue'
import type { ColumnDef } from '@tanstack/vue-table'
import { h } from 'vue'
import { PayoutsEmbed } from '../tables/Payouts'

// This type is used to define the shape of our data.
// You can use a Zod schema here if you want.
export const partialPayoutsColumns: ColumnDef<PayoutsEmbed.ListItem>[] = [
  {
    accessorKey: 'id',
  },
  {
    accessorKey: 'connectedAccount.businessName',
  },
  {
    accessorKey: 'connectedAccount.name',
  },
  {
    accessorKey: 'toBankAccountNumber',
  },
  {
    accessorKey: 'amount',
    size: 100,
  },
  {
    accessorKey: 'insertTime',
    size: 150,
  },
  {
    id: 'actions',
    meta: {
      placement: 'end',
    },
    size: 75,
    cell: ({ row, emits }) => {
      return h(PayoutListOptions, {
        payout: row.original,
        'onUpdate:close': emits.reload,
      })
    },
  },
]
